import { Dictionary } from './../models/IDictionary';
import {  Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import {LoaderState, SectionLoaderState} from 'src/app/models/LoaderState'



@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private _isLoading=new BehaviorSubject<boolean>(false);
  readonly isLoading= this._isLoading.asObservable();

  private dataStore: { isLoading:boolean,viewLoader:Dictionary<any>} = { isLoading:false,viewLoader:{}};

  private loaderSubject = new BehaviorSubject<LoaderState>({ show: false });
  loaderState = this.loaderSubject.asObservable();


  private viewLoaderSubject = new BehaviorSubject<LoaderState>(null);
  viewLoaderState = this.viewLoaderSubject.asObservable();


  private _viewLoader = new BehaviorSubject<Dictionary<any>>([]);
  readonly viewLoader = this._viewLoader.asObservable();

  public counter = 0;


constructor() { }

/*
* @@@@ NOTE @@@@
* There is two BehaviorSubject variables
* One 'loaderSubject' used for to show/hide loader in any HTTP requests
* TWO 'viewLoader' used to show/Hide loader for sectionS level (busienss logic or typescript logic code)
*/

updateLoadingState(state:boolean){

  this.dataStore.isLoading = state;
  //this._isLoading.next(Object.assign({}, this.dataStore).isLoading);
}
show() {
 this.loaderSubject.next(<LoaderState>{ show: true });
}
hide() {
  this.loaderSubject.next(<LoaderState>{ show: false });
}
showViewLoader(sectionID) {
  this.dataStore.viewLoader[sectionID] = true;
  this._viewLoader.next(Object.assign({}, this.dataStore).viewLoader);

  this.viewLoaderSubject.next(<LoaderState>{ show: true });
 }
 hideViewLoader(sectionID) {
  this.dataStore.viewLoader[sectionID] = false;
  this._viewLoader.next(Object.assign({}, this.dataStore).viewLoader);


   this.viewLoaderSubject.next(<LoaderState>{ show: false });
 }
}
